import { render } from "./Informe.vue?vue&type=template&id=51d74af8&scoped=true"
import script from "./Informe.vue?vue&type=script&lang=js"
export * from "./Informe.vue?vue&type=script&lang=js"

import "./Informe.vue?vue&type=style&index=0&id=51d74af8&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d74af8"]])

export default __exports__